import React, {useMemo} from "react";
import {AgGridReact} from "ag-grid-react";
import {Card} from "../../../../../components/card/card.jsx";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import {DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL} from "../../../../../utils/ag-grid-columns-utils.js";
import {openDispatchWeb} from "../../../utils/dispatch-list-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const ScheduleAttendanceAttendanceCard = ({attendanceList, boName}) => {
    const navigate = navigateHook();
    const attendanceColumnDefs = useMemo(() => [
        {
            field: "protocol", headerName: "Protocolo", comparator: aggridUtils.agGridNumberYearComparator, minWidth: 150,
            cellRenderer: ({data}) => (
                <button className="a-link" onClick={() => openDispatchWeb(navigate, `/attendance/form/${data.attendanceId}`)}>
                    {data.protocol}
                </button>
            ),
        },
        {field: "start", headerName: "Início", minWidth: 150, comparator: aggridUtils.agGridCompareDateTime},
        {field: "end", headerName: "Fim", minWidth: 150, comparator: aggridUtils.agGridCompareDateTime},
        {
            field: "numbercheckbook", headerName: "Despacho", comparator: aggridUtils.agGridNumberYearComparator, minWidth: 150,
            cellRenderer: ({data}) => (
                <button className="a-link" onClick={() => openDispatchWeb(navigate, `/dispatch/form/${data.dispatchId}`)}>
                    {data.numbercheckbook ?? ""}
                </button>
            ),
        },
        {
            field: "occurrenceNumber", headerName: boName, comparator: aggridUtils.agGridNumberYearComparator, minWidth: 150,
            cellRenderer: ({value}) => {
                if (!value) return "";

                const openBo = () => navigate(`/bo/redirect/${value.replace("/", "-")}`, true);
                return (
                    <button className="a-link" onClick={openBo}>
                        {value}
                    </button>
                );
            },
        },
        {
            field: "garrisonName", headerName: "Guarnição", minWidth: 220, flex: 1,
            cellRenderer: ({data}) => (
                <button className="a-link" onClick={() => openDispatchWeb(navigate, `/garrison/form/${data.garrisonId}`)}>
                    {data.garrisonName ?? ""}
                </button>
            ),
        },
    ], [boName]);

    if (!attendanceList.length) return null;

    return (
        <Card>
            <Card.Header>
                <Card.Title>Atendimentos realizados</Card.Title>
            </Card.Header>
            <Card.Body>
                <div className="h-[260px]">
                    <AgGridReact
                        rowData={attendanceList}
                        columnDefs={attendanceColumnDefs}
                        defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={aggridUtils.generalTheme()}
                    />
                </div>
            </Card.Body>
        </Card>
    );
};

export default ScheduleAttendanceAttendanceCard;
